var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/autosuggest-account-input.tsx";
const _excluded = ["onChange", "onSelected", "value", "limit"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { OrderedSet as ImmutableOrderedSet } from 'immutable';
import throttle from 'lodash/throttle';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { accountSearch } from 'soapbox/actions/accounts';
import AutosuggestInput from 'soapbox/components/autosuggest-input';
import { useAppDispatch } from 'soapbox/hooks';

const noOp = () => {};

const AutosuggestAccountInput = _ref => {
  let {
    onChange,
    onSelected,
    value = '',
    limit = 4
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const dispatch = useAppDispatch();
  const [accountIds, setAccountIds] = useState(ImmutableOrderedSet());
  const controller = useRef(new AbortController());

  const refreshCancelToken = () => {
    controller.current.abort();
    controller.current = new AbortController();
  };

  const clearResults = () => {
    setAccountIds(ImmutableOrderedSet());
  };

  const handleAccountSearch = useCallback(throttle(q => {
    const params = {
      q,
      limit,
      resolve: false
    };
    dispatch(accountSearch(params, controller.current.signal)).then(accounts => {
      const accountIds = accounts.map(account => account.id);
      setAccountIds(ImmutableOrderedSet(accountIds));
    }).catch(noOp);
  }, 900, {
    leading: true,
    trailing: true
  }), [limit]);

  const handleChange = e => {
    refreshCancelToken();
    handleAccountSearch(e.target.value);
    onChange(e);
  };

  const handleSelected = (_tokenStart, _lastToken, suggestion) => {
    if (typeof suggestion === 'string' && suggestion[0] !== '#') {
      onSelected(suggestion);
    }
  };

  useEffect(() => {
    if (value === '') {
      clearResults();
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(AutosuggestInput, _extends({
    value: value,
    onChange: handleChange,
    suggestions: accountIds.toList(),
    onSuggestionsFetchRequested: noOp,
    onSuggestionsClearRequested: noOp,
    onSuggestionSelected: handleSelected,
    searchTokens: []
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 5
    }
  }));
};

export default AutosuggestAccountInput;